import jquery from "jquery";
import 'slick-carousel';
import select2 from 'select2';
window.$ = window.jQuery = jquery;

require('jquery-ui/ui/widgets/datepicker.js');

const throttle = require('jquery-throttle-debounce/jquery.ba-throttle-debounce.js');
$.throttle = throttle.Cowboy.throttle;
$.debounce = throttle.Cowboy.debounce;

select2($);
require('select2/dist/js/i18n/fr.js');
require("@fancyapps/fancybox");

